import { render, staticRenderFns } from "./TypeComment.vue?vue&type=template&id=71eca47a&scoped=true"
import script from "./TypeComment.vue?vue&type=script&lang=js"
export * from "./TypeComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eca47a",
  null
  
)

export default component.exports